// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YQrr","comment":"styles_comment__1fth2"};